import { useQuery } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { getGoalPortfoliosV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalDetailPortfoliosQuery = () => {
	return useQuery({
		queryKey: GoalsKeys.detailPortfolios(),
		queryFn: processResponse(() => getGoalPortfoliosV2()),
	});
};
